export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "blackjackfun-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "blackjackfun-themeWrapLive" */'./LiveThemeImporter'),
  },
};
